import React, { useState, useEffect } from "react";
import "./style.css";

const FuelTypeCard = ({
  fuelList = [],
  onSelectFuel,
  selectedFuel: propSelectedFuel,
  disabled = false,
}) => {
  const [selectedFuel, setSelectedFuel] = useState(propSelectedFuel || null);

  useEffect(() => {
    setSelectedFuel(propSelectedFuel || []);
  }, [propSelectedFuel]);

  const handleFuelClick = (fuel) => {
    if (disabled) return;
    let updatedSelection = [];
    if (selectedFuel.includes(fuel)) {
      updatedSelection = selectedFuel.filter((f) => f !== fuel);
    } else {
      updatedSelection = [...selectedFuel, fuel];
    }
    setSelectedFuel(updatedSelection);
    if (onSelectFuel) {
      onSelectFuel(updatedSelection);
    }
  };

  return (
    <div className="fuel-card">
      <h3 className="fuel-title">Fuel Type</h3>

      <div className="fuel-options">
        {fuelList.map((fuel, index) => (
          <div
            key={index}
            className={`fuel-pill ${selectedFuel && selectedFuel.includes(fuel) ? "selected" : ""} ${disabled ? "disabled" : ""}`}
            onClick={() => handleFuelClick(fuel)}
          >
            <span
              className={`custom-checkbox ${selectedFuel && selectedFuel.includes(fuel) ? "checked" : ""}`}
            >
              {selectedFuel && selectedFuel.includes(fuel) && "✓"}
            </span>
            <span>{fuel}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FuelTypeCard;
